export default __webpack_public_path__ + "static/media/LandingBG.c1390f26.svg";